import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useOnClickToggleSection } from "../Hooks/useOnClickToggleSection";
import type { ButtonProps } from "./Button";

export interface EditButtonProps extends ButtonProps {
  shouldKeepSidebarOpen?: boolean;
}

export const EditButton = ({
  shouldKeepSidebarOpen = false,
  className,
  ...rest
}: EditButtonProps) => {
  const onClickHandler = useOnClickToggleSection({
    viewName: "edit",
    shouldKeepSidebarOpen,
  });

  return (
    <IconButton
      name="pencil"
      iconSize={16}
      ariaLabel={t("edit")}
      className={classNames(className)}
      onClick={onClickHandler}
      data-testid="builder-ui-edit-button"
      {...rest}
    />
  );
};
